module.exports = __webpack_public_path__ + "static/img/banner1.cd9de7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner1.jpg
// module id = nTyu
// module chunks = 12